import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { DatePipe } from '@angular/common';

import { OpsEmailLogEntry } from '../../core/status/email-log.types';
import { StatusChipComponent } from '../status-chip/status-chip';

@Component({
  selector: 'app-email-trail',
  imports: [DatePipe, StatusChipComponent],
  templateUrl: './email-trail.html',
  styleUrl: './email-trail.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailTrailComponent {
  readonly emails = input<OpsEmailLogEntry[]>([]);
  readonly loading = input(false);
  readonly error = input(false);
  readonly retry = output<void>();

  /** Per-item open/closed state keyed by email id. */
  protected readonly openBodies = signal<Set<string>>(new Set());

  protected toggleBody(id: string): void {
    this.openBodies.update((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  }

  protected isOpen(id: string): boolean {
    return this.openBodies().has(id);
  }
}
